import { Button, Modal, Text } from '@nimbus-ds/components';
import {
  paymenBoldSiginModalClick,
  paymenBoldSignupModalClick,
} from 'App/tracking';
import { openWindow } from 'commons/utils/window';
import useTranslationPayments from 'domains/Payments/useTranslationPayments';

const TRANSLATE_PREFIX = 'paymentProvider.boldConfirmModal';

interface ConfirmBoldAccountModalProps {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const CREATE_ACCOUNT_URL = 'https://panel.bold.co/onboarding/account-use';

function ConfirmBoldAccountModal({
  show,
  onClose,
  onConfirm,
}: Readonly<ConfirmBoldAccountModalProps>) {
  const t = useTranslationPayments(TRANSLATE_PREFIX);

  const handleConfirm = () => {
    paymenBoldSiginModalClick();
    onConfirm();
    onClose();
  };

  const handleCreateAccount = () => {
    openWindow(CREATE_ACCOUNT_URL, true);
    paymenBoldSignupModalClick();
    onClose();
  };
  return (
    <Modal open={show} onDismiss={onClose}>
      <Modal.Header title={t('title')} />
      <Modal.Body padding="none">
        <Text fontSize="base" lineHeight="base" textAlign="left">
          {t('text')}
        </Text>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleCreateAccount} appearance="neutral">
          {t('createAccount')}
        </Button>
        <Button onClick={handleConfirm} appearance="primary">
          {t('confirm')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ConfirmBoldAccountModal;
